import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faComments,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';

import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <>
      <section className="bg-white py-6 sm:py-12">
        <div className="w-11/12 mx-auto">
          <div className="bg-white rounded-2xl shadow-xl ring-1 ring-slate-200/80 p-6 sm:p-8">
            <h2 className="text-center text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
          Why join Golf Lists?
        </h2>
            <p className="mt-2 text-center text-sm sm:text-base text-slate-600">
              A data-first platform for comparing UK & Ireland golf courses and clubs.
            </p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
              <Link
                to="/lists/golf-courses/rankings"
                className="group rounded-2xl border border-slate-200 hover:border-slate-400 hover:bg-slate-50 p-5 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-indigo-50 border border-indigo-100 flex items-center justify-center">
                    <FontAwesomeIcon icon={faListCheck} className="text-indigo-700" />
                  </div>
                  <div className="text-lg font-extrabold text-slate-900">
                    Rankings & filters
                  </div>
                </div>
                <p className="mt-3 text-sm text-slate-600">
                  Find courses by county, style and pricing signals — fast.
                </p>
                <p className="mt-2 text-xs font-semibold text-indigo-700 group-hover:underline">
                  Explore rankings →
                </p>
              </Link>

              <Link
                to="/connect"
                className="group rounded-2xl border border-slate-200 hover:border-slate-400 hover:bg-slate-50 p-5 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-indigo-50 border border-indigo-100 flex items-center justify-center">
                    <FontAwesomeIcon icon={faComments} className="text-indigo-700" />
                  </div>
                  <div className="text-lg font-extrabold text-slate-900">
                    Community data
                  </div>
                </div>
                <p className="mt-3 text-sm text-slate-600">
                  Compare your stats, discover members, and track GFV.
                </p>
                <p className="mt-2 text-xs font-semibold text-indigo-700 group-hover:underline">
                  View Connect →
                </p>
              </Link>

              <Link
                to="/profile"
                className="group rounded-2xl border border-slate-200 hover:border-slate-400 hover:bg-slate-50 p-5 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-indigo-50 border border-indigo-100 flex items-center justify-center">
                    <FontAwesomeIcon icon={faChartLine} className="text-indigo-700" />
                  </div>
                  <div className="text-lg font-extrabold text-slate-900">
                    Your dashboard
                  </div>
                </div>
                <p className="mt-3 text-sm text-slate-600">
                  Track played courses, bucket lists and progress over time.
                </p>
                <p className="mt-2 text-xs font-semibold text-indigo-700 group-hover:underline">
                  Go to Profile →
                </p>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
